import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowService, NgsRevealService, NgsRevealConfig } from './services/index';
import { NgsRevealDirective, NgsRevealSetDirective } from './directives/index';

export { WindowService, NgsRevealService, NgsRevealConfig } from './services/index';

export { NgsRevealDirective, NgsRevealSetDirective } from './directives/index';

/**
 * Main module of the library
 */

export class NgsRevealModule {

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgsRevealModule,
      providers: [WindowService, NgsRevealService, NgsRevealConfig]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  exports: [NgsRevealDirective, NgsRevealSetDirective],
  declarations: [NgsRevealDirective, NgsRevealSetDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
